import React from "react";
import { Container, Grid } from "@mui/material";
import {
  RecipeHeader,
  RecipeDescription,
  RecipeIngredients,
  RecipeInstructions,
  RecipeImage,
} from ".";
import { StyledCard, CardContentWrapper } from "./StyledComponents";

const RecipeDetailsContent = ({ recipe, onEditClick, onImageUpload }) => {
  if (!recipe) {
    return null;
  }

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      {/* Header Card with Recipe Name and Basic Info */}
      <RecipeHeader recipe={recipe} onEditClick={onEditClick} />

      {/* Description and Image Section - Full Width */}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <StyledCard>
            <CardContentWrapper>
              <Grid container spacing={3}>
                {/* Description Column */}
                <Grid item xs={12} md={8}>
                  <RecipeDescription description={recipe.description} />
                </Grid>
                {/* Image Column */}
                <Grid item xs={12} md={4}>
                  <RecipeImage recipe={recipe} onImageUpload={onImageUpload} />
                </Grid>
              </Grid>
            </CardContentWrapper>
          </StyledCard>
        </Grid>
      </Grid>

      {/* Full Width Ingredients and Instructions */}
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <StyledCard>
            <CardContentWrapper>
              <RecipeIngredients ingredients={recipe.ingredients} />
              <RecipeInstructions instructions={recipe.instructions} />
            </CardContentWrapper>
          </StyledCard>
        </Grid>
      </Grid>
    </Container>
  );
};

export default RecipeDetailsContent;
